import { render, staticRenderFns } from "./mortgagee-form.vue?vue&type=template&id=31446ecc&scoped=true&"
import script from "./mortgagee-form.vue?vue&type=script&lang=js&"
export * from "./mortgagee-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31446ecc",
  null
  
)

export default component.exports